var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrowave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#999999",
    stroke: "#999999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.308,13H9c-2.207,0.004-3.996,1.793-4,4v32c0.004,2.207,1.793,3.996,4,4v2c0,0.553,0.447,1,1,1 s1-0.447,1-1v-2h42v2c0,0.553,0.447,1,1,1s1-0.447,1-1v-2h0.308c2.207-0.004,3.996-1.793,4-4V17 C59.304,14.793,57.515,13.004,55.308,13z M57.308,49c0,0.55-0.223,1.045-0.588,1.412C56.353,50.777,55.857,51,55.308,51H9 c-0.55,0-1.045-0.223-1.412-0.588C7.223,50.045,7,49.55,7,49V17c0-0.55,0.223-1.045,0.588-1.412C7.955,15.223,8.45,15,9,15h46.308 c0.55,0,1.045,0.223,1.412,0.588c0.365,0.367,0.588,0.862,0.588,1.412V49z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,19H14.692c-2.207,0.004-3.996,1.793-4,4v20.471c0.004,2.207,1.793,3.996,4,4H40 c2.207-0.004,3.996-1.793,4-4V23C43.996,20.793,42.207,19.004,40,19z M42,43.471c0,0.55-0.223,1.045-0.588,1.412 c-0.367,0.365-0.862,0.588-1.412,0.588H14.692c-0.55,0-1.045-0.223-1.412-0.588c-0.365-0.367-0.588-0.862-0.588-1.412V23 c0-0.55,0.223-1.045,0.588-1.412C13.647,21.223,14.143,21,14.692,21H40c0.55,0,1.045,0.223,1.412,0.588 C41.777,21.955,42,22.45,42,23V43.471z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,26h3c0.553,0,1-0.447,1-1s-0.447-1-1-1h-3c-0.553,0-1,0.447-1,1S48.447,26,49,26z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,32h3c0.553,0,1-0.447,1-1s-0.447-1-1-1h-3c-0.553,0-1,0.447-1,1S48.447,32,49,32z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5,36c-1.934,0.001-3.499,1.566-3.5,3.5c0.001,1.934,1.566,3.499,3.5,3.5 c1.934-0.001,3.499-1.566,3.5-3.5C53.999,37.566,52.434,36.001,50.5,36z M50.5,41c-0.828-0.002-1.498-0.672-1.5-1.5 c0.002-0.828,0.672-1.498,1.5-1.5c0.828,0.002,1.498,0.672,1.5,1.5C51.998,40.328,51.328,40.998,50.5,41z",
    fill: "#999999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrowave);
export default __webpack_public_path__ + "static/media/microwave.94eb47a58b7eb777d62f112a2fe8b605.svg";
export { ForwardRef as ReactComponent };